import { apiClient } from './api';

export interface AnalyticsData {
  memberCount: {
    total: number;
    byType: Record<string, number>;
  };
  serviceUsage: {
    totalRequests: number;
    byType: Array<{
      type: string;
      count: number;
    }>;
    byStatus: Array<{
      status: string;
      count: number;
    }>;
  };
  comparison: {
    corporate: {
      memberCount: number;
      serviceRequests: number;
      revenue: number;
    };
    individual: {
      memberCount: number;
      serviceRequests: number;
      revenue: number;
    };
    family: {
      memberCount: number;
      serviceRequests: number;
      revenue: number;
    };
  };
  renewals: {
    upcomingRenewals: Array<{
      memberId: string;
      memberName: string;
      membershipType: string;
      validUntil: string;
      daysUntilExpiry: number;
    }>;
    expiringThisMonth: number;
    expiringNextMonth: number;
    churnRate: number;
  };
}

class AnalyticsService {
  async getAnalytics(filters?: {
    startDate?: string;
    endDate?: string;
  }): Promise<AnalyticsData> {
    return apiClient.get<AnalyticsData>('/admin/analytics', filters);
  }
}

export const analyticsService = new AnalyticsService();
